var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-breadcrumb', [_c('a-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/courseHome"
    }
  }, [_vm._v("课程首页")])]), _c('a-breadcrumb-item', [_vm._v("课程列表")])], 1), _c('a-divider'), _vm.loading ? _c('a-skeleton') : _vm._e(), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticStyle: {
            "height": "250px"
          },
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.courseCover_url,
            "alt": ""
          }
        })]), _c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.courseName))])])], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };